<div class="sso-landing" tid="sso-landing">
  @if (status === 'processing') {
    <div class="sso-landing__content">
      <app-in-flight-spinner
        [fullSize]="false"
        [diameter]="48"
        tid="sso-landing-spinner"
      ></app-in-flight-spinner>
      <app-h2 class="sso-landing__title">Completing sign in</app-h2>
      <app-body-md class="sso-landing__message"
        >Please wait while we sign you in…</app-body-md
      >
    </div>
  }
  @if (status === 'success') {
    <div class="sso-landing__content">
      <app-h2 class="sso-landing__title">Sign in successful</app-h2>
      <app-body-md class="sso-landing__message"
        >Redirecting you into the app…</app-body-md
      >
    </div>
  }
  @if (status === 'error') {
    <div class="sso-landing__content">
      <app-h2 class="sso-landing__title">Something went wrong</app-h2>
      <app-body-md class="sso-landing__message"
        >Redirecting you to sign in…</app-body-md
      >
    </div>
  }
</div>
